import React, {Fragment} from "react";
import styled from "styled-components";

import More from "./More";
import Error from "layouts/Error";
import iconLoading from "assets/icons/icon_loading.gif";

export const Section = ({onClick, onRefresh, ...props}) => {
	const getClassName = () => {
		const nameList = [];
		if(props.isLoading) nameList.push("loading");
		if(props.isError) nameList.push("error");
		if(props.isMore) nameList.push("more");
		return nameList.join(" ");
	};
	return (
		<Wrapper {...props} className={getClassName()}>
			{(!props.isError && (props.title || props.text)) ? (
				<div className="top">
					<More icon={props.icon} title={props.title} text={props.text} href={props.href} onClick={onClick} />
				</div>
			) : null}
			{(props.children) ? (
				<Fragment>
					<div className="middle">
						{props.children}
					</div>
					<div className="bottom" />
				</Fragment>
			) : null}
			{(props.isError) ? (
				<Error mode="section" onRefresh={onRefresh} />
			) : null}
		</Wrapper>
	);
};


const Wrapper = styled.section`
&					{position:relative; padding:24px; background-color:white; border-radius:var(--borderRadius); overflow:hidden}
& + &				{margin-top:var(--padding)}
&.more				{padding-bottom:5px}	
&.loading			{}	
&.loading:after		{content:""; position:absolute; left:0; top:0; right:0; bottom:0; background:rgba(255,255,255,0.85) url(${iconLoading}) no-repeat center center / 50px}
& > .top + .middle	{margin-top:5px}
&.error 			{min-height:100px}
&.error > .middle	{visibility:hidden}
`;


export default Section;